import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import '../../../css/huerto/modalsFichaLPO.css';
import Datepicker from '../../../bronson/Datepicker';
import ContractsService from '../../../../services/ContractsService';
import Globals from '../../../../Globals';
import FunctionGeneral from '../functionsGeneral';
import Input from '../../../bronson/Input';

function formatFechaLPOExpiration(date) {
    let _date = date.split('T')[0].split('-');
    let fechaReturn = new Date();
    fechaReturn.setDate(_date[2] - 2);
    fechaReturn.setMonth(_date[1] - 1);
    fechaReturn.setFullYear(_date[0]);

    return (
        fechaReturn.getDate() +
        '/' +
        (fechaReturn.getMonth() + 1) +
        '/' +
        fechaReturn.getFullYear()
    );
}
function formatFechaLPO(dataFecha) {
    try {
        dataFecha = dataFecha.split('T')[0];
        dataFecha = dataFecha.split('-');
        return dataFecha[2] + '/' + dataFecha[1] + '/' + dataFecha[0];
    } catch {
        return '';
    }
}
function SHOW(element) {
    let elementTarget = document.getElementById(element);
    if (elementTarget.style.display == 'none') {
        document.getElementById(element + '_active').classList.add('is-active');
        elementTarget.style.display = '';
    } else {
        document
            .getElementById(element + '_active')
            .classList.remove('is-active');
        elementTarget.style.display = 'none';
    }
}

function ModalSeleccionLPO(props) {
    const selectedVinsCookieName =
        'LPO_SELECTED_VINS_' + String(props.operacionCodeLPO || '').trim();

    const [scrollTable, setscrollTable] = useState(false);
    const [datePickerFromValue, setDatePickerFromValue] = useState(
        new FunctionGeneral().fechainicial()
    );
    const [dateCalculo, setDateCalculo] = useState([]);
    const [SeleccionLPOResult, setSeleccionLPOResult] = useState([]);
    // const [resultSendCerticate, setresultSendCerticate] = useState([]);
    const [listSeleccionLPO, setListSeleccionLPO] = useState([]);
    const [SeleccionLPOError, setSeleccionLPOError] = useState('');
    const [resultadoLPO, setResultadoLPO] = useState(null);
    const [showResultadoLPO, setShowResultadoLPO] = useState(false);

    const readSelectedVinsCookie = () => {
        try {
            const cookieValue = props.cookies.get(selectedVinsCookieName);
            if (!cookieValue) return [];

            const parsed =
                typeof cookieValue === 'string'
                    ? JSON.parse(cookieValue)
                    : cookieValue;

            if (!Array.isArray(parsed)) return [];

            return parsed
                .filter(item => typeof item === 'string' && item.trim() !== '')
                .map(item => item.trim());
        } catch {
            return [];
        }
    };

    const saveSelectedVinsCookie = vins => {
        try {
            props.cookies.set(selectedVinsCookieName, JSON.stringify(vins), {
                path: '/',
                maxAge: 60 * 60,
            });
        } catch {
            // Ignore cookie persistence errors and keep selection in memory.
        }
    };

    const clearSelectedVinsCookie = () => {
        try {
            props.cookies.remove(selectedVinsCookieName, {
                path: '/',
            });
        } catch {
            // Ignore cookie remove errors.
        }
    };

    const closeModalSeleccionLPO = () => {
        clearSelectedVinsCookie();
        props.setModalSeleccionLPO(false);
    };

    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
        if (document.querySelector('#fecha-SimulacionLPO').value == '') {
            document.querySelector(
                '#fecha-SimulacionLPO'
            ).value = new FunctionGeneral().fechainicial();
            newLPO(document.querySelector('#fecha-SimulacionLPO').value);
        }
    }, [dateCalculo]);

    useEffect(() => {
        const cookieVins = readSelectedVinsCookie();
        if (cookieVins.length > 0) {
            setListSeleccionLPO(cookieVins);
        }
    }, [selectedVinsCookieName]);

    async function newLPOID(valueDate) {
        props.setLoading(true);
        // Reset persisted selection at every calculation attempt to avoid stale data.
        clearSelectedVinsCookie();
        setDatePickerFromValue(valueDate);

        var selected = [];
        SeleccionLPOResult.map((row, index) =>
            listSeleccionLPO.includes(row.vin_code) ? selected.push(row) : null
        );
        let _date = valueDate.split('T')[0].split('/');
        var _newSolicitudLPO = await new ContractsService().simulacionLPO(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.cookies.get(Globals.COOKIES.USER),
            props.operacionCodeLPO,
            _date[2] + '-' + _date[1] + '-' + _date[0],
            selected
        );
        if (
            _newSolicitudLPO &&
            _newSolicitudLPO.statusCode === 200 &&
            _newSolicitudLPO.body &&
            _newSolicitudLPO.body.Result
        ) {
            var newSolicitudLPOResult = JSON.parse(
                _newSolicitudLPO.body.Result
            );
            saveSelectedVinsCookie(listSeleccionLPO);
            setSeleccionLPOError('');
            setResultadoLPO(newSolicitudLPOResult);
            setShowResultadoLPO(true);
            if (props.setDataSimulacionProps)
                props.setDataSimulacionProps();
            props.setLoading(false);
        } else {
            setSeleccionLPOError(
                _newSolicitudLPO &&
                    _newSolicitudLPO.body &&
                    _newSolicitudLPO.body.Errors &&
                    _newSolicitudLPO.body.Errors.length > 0
                    ? _newSolicitudLPO.body.Errors[0].Value
                    : 'No se pudo generar la simulación LPO.'
            );
            props.setLoading(false);
        }
    }

    async function newLPO(valueDate) {
        props.setLoading(true);
        let _date = valueDate.split('T')[0].split('/');
        var _newSeleccionLPO = await new ContractsService().newSeleccionLPO(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.cookies.get(Globals.COOKIES.USER),
            props.operacionCodeLPO,
            _date[2] + '-' + _date[1] + '-' + _date[0]
        );
        if (
            _newSeleccionLPO &&
            _newSeleccionLPO.statusCode === 200 &&
            _newSeleccionLPO.body &&
            _newSeleccionLPO.body?.Errors?.length == 0 &&
            _newSeleccionLPO.body.Result
        ) {
            setSeleccionLPOError('');
            var newSeleccionLPO = JSON.parse(_newSeleccionLPO.body.Result);
            setSeleccionLPOResult(newSeleccionLPO);
            props.setLoading(false);
        } else {
            setSeleccionLPOError(_newSeleccionLPO.body?.Errors[0]?.Value);
            props.setLoading(false);
        }
    }

    function calcular() {
        newLPOID(document.querySelector('#fecha-SimulacionLPO').value);
    }

    function addSeleccionLPO(Bastidor) {
        var _listSeleccionLPO = JSON.parse(JSON.stringify(listSeleccionLPO));
        if (_listSeleccionLPO.includes(Bastidor))
            _listSeleccionLPO.splice(_listSeleccionLPO.indexOf(Bastidor), 1);
        else _listSeleccionLPO.push(Bastidor);

        setListSeleccionLPO(_listSeleccionLPO);
    }

    const printCalculo = () => {
        if (props.cancelacionLPOIDSelect === '' /* && !scrollTable*/)
            return (
                <div className="u-1/1">
                    <div className="u-1/1">
                        <label className="u-text-base u-text-left u-1/1">
                            Selecciona la fecha y el/los vehículo(s) sobre
                            el/los que deseas realizar la simulación.
                        </label>
                    </div>
                    <div className="u-mt">
                        <div className="u-text-left">
                            <label className="u-text-base u-text-left">
                                Fecha cancelación
                            </label>
                        </div>
                        <div className="input-div u-float-left">
                            <Datepicker
                                options={{
                                    id: 'fecha-SimulacionLPO',
                                    type: 'date',
                                    minDate: new FunctionGeneral().fechainicial(),
                                    maxDate: formatFechaLPOExpiration(
                                        props?.fecha_expirate
                                    ),
                                }}
                                onChange={() => {}}
                            ></Datepicker>
                        </div>
                    </div>
                    <div className="u-1/1">
                        <button
                            className="c-btn u-float-left "
                            style={{
                                display: 'flow-root',
                                width: '100px',
                                height: '28px',
                                marginLeft: '15px',
                            }}
                            disabled={listSeleccionLPO.length == 0}
                            onClick={() => {
                                calcular();
                            }}
                        >
                            Calcular
                        </button>
                    </div>
                </div>
            );
        else return null;
    };

    const showSeleccionLPOError = () => {
        if (SeleccionLPOError && SeleccionLPOError != '')
            return (
                <div className="u-1/1">
                    <div className="u-1/1">
                        <label className="u-text-base u-text-left u-1/1">
                            {SeleccionLPOError}
                        </label>
                    </div>
                </div>
            );
        else return null;
    };

    const showSeleccionLPO = () => {
        return (
            <div className="u-1/1 c-table-wrapper c-table--wide tablaSeleccionLPO">
                <table className="u-hide@l">
                    <thead>
                        <tr>
                            <th scope="col" style={{ width: '10px' }}></th>
                            <th scope="col">Matrícula</th>
                            <th scope="col">Bastidor</th>
                            {/*<th scope="col">C.Amortizado</th>*/}
                            {/* <th scope="col">Modelo</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {SeleccionLPOResult.map((row, index) => (
                            <tr
                                id={row.vin_code}
                                key={row.vin_code}
                                onClick={() => addSeleccionLPO(row.vin_code)}
                            >
                                <td>
                                    <input
                                        className="c-checkbox__input"
                                        type="checkbox"
                                        name="checkbox"
                                        id={
                                            'checkboxSeleccionLPO' +
                                            row.vin_code
                                        }
                                        readOnly={true}
                                        checked={
                                            listSeleccionLPO &&
                                            listSeleccionLPO.length > 0 &&
                                            listSeleccionLPO.includes(
                                                row.vin_code
                                            )
                                                ? true
                                                : false
                                        }
                                    />
                                    <span className="c-checkbox__label"></span>
                                </td>
                                <td className="u-text-truncate marcaTruncate">
                                    {row.license_plate}
                                </td>
                                <td scope="row" className="u-text-truncate">
                                    {row.vin_code}
                                </td>
                                {/* <td scope="row" className="u-text-truncate">
                                    {row.amortized_capital}
                                </td> */}
                                {/* <td scope="row" className="u-text-truncate">
                                        cuatro
                                    </td> */}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    const showValue = (value, isMoney = false, isDate = false) => {
        if (value === undefined || value === null || value === '') return '-';
        if (isDate) return formatFechaLPO(value);
        if (isMoney) return new FunctionGeneral().formatNum(value) + '€';
        return value;
    };

    const isZeroLikeValue = value => {
        if (value === undefined || value === null || value === '') return true;
        const normalized = String(value)
            .trim()
            .replace(/\./g, '')
            .replace(',', '.');
        const asNumber = Number(normalized);
        return !Number.isNaN(asNumber) && asNumber === 0;
    };

    const shouldShowMoneyRow = value => !isZeroLikeValue(value);

    const formatPercent = (value, digits = 3) => {
        if (value === undefined || value === null || value === '') return '-';

        const normalized = String(value).trim().replace(',', '.');
        const asNumber = Number(normalized);
        if (Number.isNaN(asNumber)) return String(value);

        return new FunctionGeneral().formatNum(asNumber.toFixed(digits));
    };

    const renderSummaryRow = (
        label,
        value,
        options = { isMoney: false, isDate: false, bold: false }
    ) => {
        const boldClass = options.bold ? ' u-text-bold' : '';
        const labelBoldClass =
            options.bold || options.boldLabel ? ' u-text-bold' : '';

        return (
            <React.Fragment key={label}>
                <label
                    className={'o-layout__item u-1/2 labelConsT' + labelBoldClass}
                >
                    {label}
                </label>
                <label
                    className={
                        'o-layout__item u-1/2 labelConsT u-text-right u-pr' +
                        boldClass
                    }
                >
                    {showValue(value, options.isMoney, options.isDate)}
                </label>
            </React.Fragment>
        );
    };

    const getResultList = data => {
        if (!data) return [];
        if (Array.isArray(data)) return data;

        const arrayContainers = [
            'Settlements',
            'settlements',
            'SettlementList',
            'settlementList',
            'Result',
            'result',
            'Data',
            'data',
            'Items',
            'items',
        ];

        for (let i = 0; i < arrayContainers.length; i++) {
            const candidate = data[arrayContainers[i]];
            if (Array.isArray(candidate)) return candidate;
        }

        return [data];
    };

    const mapResultToBusinessData = result => {
        return {
            paymentDate: result.payment_date,
            amortizedCapital: result.amortized_capital,
            settlementFeeRate: result.settlementfee_rate,
            settlementFeeAmount: result.settlementfee_amount,
            accruedInterestDays: result.accruedinterest_days,
            accruedInterestAmount: result.accruedinterest_amount,
            numObjects: result.num_objects,
            settledInsurance: result.settled_insurance,
            unpaidBalance: result.unpaid_balance,
            pendingSettlements: result.pending_settlements,
            pendingArrears: result.pending_arrears,
            penaltyAmount: result.penalty_amount,
            openingComAmount: result.opening_com_amount,
            penaltyEndDate: result.penalty_end_date,
            settlementAmount: result.settlement_amount,
            total: result.total,
            pendingCapitalDate: result.pendingcapital_date,
            formerPendingCapitalAmount: result.former_pendingcapital_amount,
            pendingCapitalAmount: result.pendingcapital_amount,
            formerNextDueDate: result.former_next_duedate,
            nextDueDate: result.next_duedate,
            formerEndDate: result.former_end_date,
            endDate: result.end_date,
            formerPendingLength: result.former_pending_length,
            pendingLength: result.pending_length,
            formerPendingAmount: result.former_pending_amount,
            pendingAmount: result.pending_amount,
            formerPendingInterest: result.former_pending_interest,
            pendingInterest: result.pending_interest,
            newInstallmentAmount: result.new_installment_amount,
            codeTransfer: result.code_transfer,
            penaltyDetailsTable: Array.isArray(result.penalty_details_table)
                ? result.penalty_details_table
                : [],
        };
    };

    const getFirstValue = (source, keyList) => {
        for (let i = 0; i < keyList.length; i++) {
            const value = source?.[keyList[i]];
            if (value !== undefined && value !== null && String(value).trim() !== '')
                return value;
        }

        return '';
    };

    const renderComparisonRows = businessData => {
        const pendingCapitalLabel = businessData.pendingCapitalDate
            ? 'Capital pendiente al ' +
              showValue(businessData.pendingCapitalDate, false, true)
            : 'Capital pendiente';

        const rows = [
            {
                label: pendingCapitalLabel,
                previous: businessData.formerPendingCapitalAmount,
                current: businessData.pendingCapitalAmount,
                isMoney: true,
            },
            {
                label: 'Primer vencimiento',
                previous: businessData.formerNextDueDate,
                current: businessData.nextDueDate,
                isDate: true,
            },
            {
                label: 'Último vencimiento remesable',
                previous: businessData.formerEndDate,
                current: businessData.endDate,
                isDate: true,
            },
            {
                label: 'Períodos de pago pendientes',
                previous: businessData.formerPendingLength,
                current: businessData.pendingLength,
            },
            {
                label: 'Importe nominal cuotas pendientes',
                previous: businessData.formerPendingAmount,
                current: businessData.pendingAmount,
                isMoney: true,
            },
            {
                label: 'Importe intereses cuotas pendientes',
                previous: businessData.formerPendingInterest,
                current: businessData.pendingInterest,
                isMoney: true,
            },
        ];

        return rows.map(row => (
            <tr key={row.label}>
                <td>{row.label}</td>
                <td className="u-text-right">
                    {showValue(row.previous, row.isMoney, row.isDate)}
                </td>
                <td className="u-text-right">
                    {showValue(row.current, row.isMoney, row.isDate)}
                </td>
            </tr>
        ));
    };

    const renderTransferBlock = businessData => {
        if (!businessData.codeTransfer) return null;

        return (
            <div className="u-1/1 infoResumen lpo-transfer-block">
                <label className="o-layout__item u-1/1 labelConsT">
                    Para proceder a la cancelación se deberá transferir el
                    importe anterior en la fecha indicada a la cuenta bancaria:
                </label>

                {renderSummaryRow(
                    'Banco',
                    'VOLKSWAGEN BANK GmbH Sucursal en España',
                    { boldLabel: true }
                )}
                {renderSummaryRow('IBAN', 'ES08 1480 0010 9101 0000 0562', {
                    boldLabel: true,
                })}

                {renderSummaryRow(
                    'Concepto de la transferencia',
                    businessData.codeTransfer,
                    { bold: true }
                )}
            </div>
        );
    };

    const printResultFields = result => {
        const businessData = mapResultToBusinessData(result);
        const selectedVinsForSummary =
            listSeleccionLPO.length > 0
                ? listSeleccionLPO
                : readSelectedVinsCookie();
        const operationSituation =
            getFirstValue(result, [
                'situation',
                'status',
                'operation_status',
                'contract_status',
            ]) || '-';
        // El WS devuelve payment_date con 2 dias añadidos: mostramos la fecha elegida por el cliente.
        const fechaPagoSeleccionada =
            datePickerFromValue ||
            showValue(businessData.paymentDate, false, true);

        const detailLeftRows = [
            {
                label: 'Capital liquidado',
                value: businessData.amortizedCapital,
                isMoney: true,
            },
            {
                label:
                    'Comisión cancelación (' +
                    formatPercent(businessData.settlementFeeRate) +
                    '%)',
                value: businessData.settlementFeeAmount,
                isMoney: true,
            },
            {
                label:
                    showValue(businessData.accruedInterestDays) +
                    ' días de interés',
                value: businessData.accruedInterestAmount,
                isMoney: true,
            },
            {
                label: 'Importe prima seguro cancelado',
                value: businessData.settledInsurance,
                isMoney: true,
            },
            {
                label: 'Importe cuotas abonadas anticipadas',
                value: businessData.pendingSettlements,
                isMoney: true,
            },
            {
                label: 'Importe nueva cuota',
                value: businessData.newInstallmentAmount,
                isMoney: true,
            },
        ];

        const detailRightRows = [
            {
                label: 'Reintegro de subvenciones/bonificaciones',
                value: businessData.penaltyAmount,
                isMoney: true,
            },
            {
                label: 'Devolución comisión apertura no devengada',
                value: businessData.openingComAmount,
                isMoney: true,
            },
            {
                label: 'Importe cancelación',
                value: businessData.settlementAmount,
                isMoney: true,
            },
            {
                label: 'Saldo impagado',
                value: businessData.unpaidBalance,
                isMoney: true,
            },
            {
                label: 'Mora pendiente',
                value: businessData.pendingArrears,
                isMoney: true,
            },
        ];

        return (
            <div className="u-1/1">
                <div className="u-1/1 infoResumen lpo-block-a">
                    <div className="o-layout lpo-inline-rows">
                        <div className="o-layout__item u-1/3">
                            <div className="lpo-inline-row">
                                <span className="lpo-inline-label">Operación:</span>
                                <span className="lpo-inline-value">
                                    {showValue(props.operacionCodeLPO)}
                                </span>
                            </div>
                        </div>
                        <div className="o-layout__item u-1/3">
                            <div className="lpo-inline-row">
                                <span className="lpo-inline-label">Situación:</span>
                                <span className="lpo-inline-value">
                                    {showValue(operationSituation)}
                                </span>
                            </div>
                        </div>
                        <div className="o-layout__item u-1/3">
                            <div className="lpo-inline-row">
                                <span className="lpo-inline-label">Fecha de pago:</span>
                                <span className="lpo-inline-value">
                                    {showValue(fechaPagoSeleccionada)}
                                </span>
                            </div>
                        </div>
                        <div className="o-layout__item u-1/3">
                            <div className="lpo-inline-row">
                                <span className="lpo-inline-label">Objetos cancelados:</span>
                                <span className="lpo-inline-value">
                                    {showValue(businessData.numObjects)}
                                </span>
                            </div>
                        </div>
                        <div className="o-layout__item u-1/1">
                            <div className="lpo-inline-row">
                                <span className="lpo-inline-label">Bastidores seleccionados:</span>
                                <span className="lpo-inline-value">
                                    {selectedVinsForSummary.length > 0
                                        ? selectedVinsForSummary.join(', ')
                                        : '-'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="u-1/1 infoResumen lpo-block-b u-mt-small">
                    <table className="lpo-comparison-table">
                        <thead>
                            <tr>
                                <th>Detalle</th>
                                <th>Previo cancelación</th>
                                <th>Después cancelación</th>
                            </tr>
                        </thead>
                        <tbody>{renderComparisonRows(businessData)}</tbody>
                    </table>
                </div>

                <div className="u-1/1 infoResumen lpo-block-c u-mt-small">
                    <div className="o-layout">
                        <div className="o-layout__item u-1/2">
                            {detailLeftRows.map(row =>
                                renderSummaryRow(row.label, row.value, {
                                    isMoney: row.isMoney,
                                })
                            )}
                        </div>
                        <div className="o-layout__item u-1/2">
                            {detailRightRows.map(row =>
                                renderSummaryRow(row.label, row.value, {
                                    isMoney: row.isMoney,
                                })
                            )}
                        </div>
                    </div>

                    <div className="u-1/1" style={{ height: '10px' }}>
                        <hr />
                    </div>

                    {renderSummaryRow('Total a ingresar', businessData.total, {
                        isMoney: true,
                        bold: true,
                    })}
                </div>

                {renderTransferBlock(businessData)}
            </div>
        );
    };

    const showResultado = () => {
        if (!showResultadoLPO || resultadoLPO === null) return null;

        const resultList = getResultList(resultadoLPO);

        return (
            <div className="u-1/1 u-pt-small">
                <h5 className="colorBlue u-text-left u-h6">Resumen simulación LPO</h5>
                {resultList.map((result, index) => (
                    <div
                        key={index}
                        className="u-1/1"
                        style={{
                            border: '1px solid #d4d7db',
                            borderRadius: '4px',
                            padding: '10px',
                            marginBottom: '12px',
                        }}
                    >
                        <label className="u-text-left u-text-bold u-1/1 u-pb-small">
                            {resultList.length > 1
                                ? 'Vehículo ' + (index + 1)
                                : 'Resultado'}
                        </label>
                        {printResultFields(result)}

                        {mapResultToBusinessData(result).penaltyDetailsTable
                            .filter(item => !isZeroLikeValue(item.penalty_details))
                            .length > 0 && (
                                <div className="u-1/1 u-mt-small">
                                    <label className="u-text-left u-text-bold u-1/1 u-pb-small">
                                        Detalle penalización
                                    </label>
                                    {mapResultToBusinessData(result).penaltyDetailsTable
                                        .filter(
                                            item =>
                                                !isZeroLikeValue(
                                                    item.penalty_details
                                                )
                                        )
                                        .map(
                                        (desglose, desgloseIndex) => (
                                            <div
                                                key={desgloseIndex}
                                                className="o-split"
                                                style={{
                                                    backgroundColor:
                                                        desgloseIndex % 2 === 0
                                                            ? 'rgb(242, 242, 242)'
                                                            : '',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        lineHeight: '24px',
                                                        margin: '0px',
                                                    }}
                                                >
                                                    {showValue(
                                                        'Penalización ' +
                                                            (desgloseIndex + 1)
                                                    )}
                                                </p>
                                                <p
                                                    style={{
                                                        lineHeight: '24px',
                                                        margin: '0px',
                                                        marginLeft: '5px',
                                                    }}
                                                >
                                                    {showValue(
                                                        desglose.penalty_details,
                                                        true,
                                                        false
                                                    )}
                                                </p>
                                            </div>
                                        )
                                    )}
                                </div>
                            )}
                    </div>
                ))}

                <div className="u-1/1 lpo-result-actions">
                    <button
                        className="c-btn c-btn--secondary"
                        onClick={() => {
                            setShowResultadoLPO(false);
                            setResultadoLPO(null);
                        }}
                    >
                        NUEVA SIMULACIÓN
                    </button>
                    <button
                        className="c-btn c-btn--secondary u-pl-large u-pr-large"
                        onClick={() => closeModalSeleccionLPO()}
                    >
                        CERRAR
                    </button>
                </div>
            </div>
        );
    };

    return (
        <div className="c-modal" aria-hidden={'false'}>
            <div className="c-modal__overlay js-modal-close"></div>
            <div
                className="c-modal__wrapper modalFichaCliente modalSeleccionLPO"
                role="dialog"
                aria-labelledby="foo-bar-baz"
            >
                <header className="c-modal__header">
                    <div className="o-layout__item u-11/12">
                        <label className="u-h3 u-ml-xsmall">
                            Simulación de cancelación parcial de un contrato
                        </label>
                    </div>

                    <div className="u-1/12">
                        <button
                            onClick={() => closeModalSeleccionLPO()}
                            className="c-modal__close-btn  js-modal-close"
                            type="button"
                            aria-label="Close this dialog window."
                        />
                    </div>
                </header>

                <div className="c-modal__content">
                    <section style={{ minHeight: '150px', display: 'grid' }}>
                        {!showResultadoLPO && (
                            <React.Fragment>
                                <div style={{ marginBottom: '20px' }}>
                                    <p className="u-text-left">
                                        A continuación puedes realizar
                                        simulaciones de cancelación parcial por
                                        bastidor.
                                    </p>
                                </div>
                                {printCalculo()}
                                <br></br>
                                {showSeleccionLPOError()}
                                {SeleccionLPOResult &&
                                    SeleccionLPOResult.length > 0 &&
                                    showSeleccionLPO()}
                            </React.Fragment>
                        )}
                        {showResultadoLPO && showResultado()}
                    </section>
                    {!showResultadoLPO && (
                        <div
                            className="o-layout__item u-1/1"
                            style={{
                                marginTop: '65px',
                            }}
                        >
                            <div className="u-1/2 u-float-left">
                                <button
                                    className="c-btn--secondary c-btn u-p-small u-pl-large u-pr-large"
                                    onClick={() => closeModalSeleccionLPO()}
                                >
                                    CERRAR
                                </button>
                            </div>
                            <div className="u-1/2 u-float-left"></div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
export default withCookies(withRouter(ModalSeleccionLPO));
